import className from 'classnames/bind';
import { PILL_ICONS } from '@/core/icons';
import { forwardRef, useRef, useImperativeHandle } from 'react';

import styles from './TypePill.module.scss';
import { usePageWrapperData } from '@/providers/PageWrapperContext';
const cx = className.bind(styles);

interface TypePillProps {
  type: string;
  className?: string;
  copy?: string;
}

export interface TypePillRefs {
  rootEl?: HTMLDivElement | null;
  backgroundEl?: HTMLDivElement | null;
  iconEl?: HTMLSpanElement | null;
  textEl?: HTMLSpanElement | null;
}

const TypePill = forwardRef<TypePillRefs, TypePillProps>(
  ({ type, className, copy }, ref) => {
    const Icon = PILL_ICONS[type.toLowerCase()] || null;
    const { labels } = usePageWrapperData();

    const rootEl = useRef<HTMLDivElement | null>(null);
    const backgroundEl = useRef<HTMLDivElement | null>(null);
    const iconEl = useRef<HTMLSpanElement | null>(null);
    const textEl = useRef<HTMLSpanElement | null>(null);

    // Expose the refs to the parent
    useImperativeHandle(ref, () => ({
      rootEl: rootEl.current,
      backgroundEl: backgroundEl.current,
      iconEl: iconEl.current,
      textEl: textEl.current,
    }));

    return (
      <div className={cx(['type-pill', className])} aria-label={type ? `${labels?.category} ${type}` : ""} ref={rootEl}>
        <div className={cx('type-pill__background')} ref={backgroundEl}></div>
        {Icon && (
          <span ref={iconEl}>
            <Icon />
          </span>
        )}
        <span ref={textEl} className={cx('eyebrow-l', 'copy')}>
          {copy || type}
        </span>
      </div>
    );
  }
);

export default TypePill;
